/** Curriculum v2 UI (prefix v2.*): new lesson items, scaffold, map nodes / chapters / finale / crossroads, playground levels, golden frames. */
export const en = {
  // stroke player (scaffold + masterpiece sessions)
  'v2.session1': 'Session 1: shapes & overlaps',
  'v2.session2': 'Session 2: details, shadow & colour',
  'v2.breakHint': 'Tired hands? Your place is saved.',
  'v2.takeBreak': 'Take a break',
  'v2.needHint': 'Need a hint?',
  // story beats
  'v2.chapter': 'Chapter {n}',
  'v2.finaleTitle': 'The end of the story',
  'v2.storyGo': "Let's go!",
  'v2.storyEnd': 'The end!',
  'v2.guide.scribble': 'Scribble',
  'v2.guide.miso': 'Miso',
  'v2.guide.hatDe': 'Chestnut',
  'v2.guide.bolt': 'Bolt',
  'v2.guide.nova': 'Nova',
  'v2.guide.banhBao': 'Bunbun',
  // remix picker
  'v2.remixTap': 'Tap a card to flip it',
  'v2.remixPick': 'Draw this one!',
  'v2.remixTryNew': 'Try a new one!',
  'v2.remixLast': 'Last time',
  'v2.remixOthers': 'The other cards wait for you in the Playground',
  // scene stage
  'v2.sceneFar': 'Far',
  'v2.sceneMid': 'Middle',
  'v2.sceneNear': 'Near',
  'v2.sceneHorizon': 'Horizon',
  'v2.sceneOrder': 'Background first, then from back to front',
  'v2.sceneOrderOverlap': 'Front friend first: the ones behind stop at its edge',
  'v2.sceneLayout': 'Layout {n}',
  'v2.sceneSwap': 'Swap a friend',
  'v2.sceneGo': 'Start drawing',
  // memory peek + self check
  'v2.pickSubject': 'Pick what to draw',
  'v2.peekStart': "I'm ready to look",
  'v2.peekLook': 'Look closely…',
  'v2.peekHidden': 'Now draw it from memory!',
  'v2.peekOwnPose': 'Draw it from memory, in your own pose!',
  'v2.peekNoGuides': 'No steps, no helper lines: you can do it!',
  'v2.peekAgain': 'Peek again ({n} left)',
  'v2.peekExtra': 'Peek again (no star)',
  'v2.peekDone': 'I finished drawing',
  'v2.peeksUsed': 'Peeks: {n}',
  'v2.checkDone': 'I checked my drawing',
  'v2.checkCount': '{n} of {total} remembered',
  // observe
  'v2.obsSafety': 'Safety first',
  'v2.obsSafetyOk': 'Got it!',
  'v2.obsPutObject': 'Put this in front of you:',
  'v2.obsCard': 'Card {n} of {total}',
  'v2.obsNext': 'Next card',
  'v2.obsDone': "Let's draw!",
  'v2.obsPhoto': 'Snap your object (optional)',
  'v2.obsPhotoTake': 'Take a photo',
  'v2.obsPhotoSkip': 'No photo',
  'v2.obsPhotoSaved': 'Saved on this device only',
  'v2.obsCompareNoPhoto': "No object photo this time, and that's fine!",
  'v2.obsObject': 'Your object',
  'v2.obsYours': 'Your drawing',
  // then & now
  'v2.thenTitle': 'Back then',
  'v2.nowTitle': 'Now',
  'v2.thenJuno': "Juno's drawing back then",
  'v2.thenYours': 'Your drawing back then',
  'v2.thenSlide': 'Slide to compare',
  'v2.thenShare': 'Make a share card',
  'v2.thenCardTitle': 'Then & Now',
  'v2.share': 'Share',
  'v2.save': 'Save',
  // print sheet
  'v2.printTrace': 'Trace sheet',
  'v2.printColour': 'Colouring page',
  'v2.printName': 'Name:',
  'v2.print': 'Print',
  'v2.printSave': 'Save picture',
  'v2.printSkip': 'Skip',
  'v2.printMaking': 'Making your sheet…',
  // celebrations
  'v2.celSmall': 'Quick win!',
  'v2.celKey': 'You earned the level key!',
  'v2.celMasterpiece': 'A masterpiece!',
  'v2.celGolden': 'A golden frame waits in your gallery',
  'v2.celBadgeStar': 'Confident artist star!',
  'v2.celBadgeLess': 'Next time try peeking less!',
  'v2.celBadgePhoto': 'Take a photo next time to earn the star',
  'v2.confident': 'Confident artist',
  // map
  'v2.new': 'New!',
  'v2.act.doodle': 'Quick doodle',
  'v2.act.core': 'Lesson',
  'v2.act.remix': 'Remix',
  'v2.act.colouring': 'Colouring',
  'v2.act.scene': 'Scene',
  'v2.act.masterpiece': 'Masterpiece',
  'v2.act.thenNow': 'Then & now',
  'v2.act.challenge': 'Challenge',
  'v2.act.observe': 'Real object',
  'v2.act.crossover': 'Crossover',
  'v2.act.picture': 'Picture',
  'v2.picLocked': 'Draw the {name} lesson first, then reach level {n} of this world',
  'v2.picLevel': 'Reach level {n} of this world to paint the full picture',
  'v2.picTier': 'Paint the picture',
  'v2.gallery': 'Exhibition room',
  'v2.galleryLocked': 'Paint a picture of this world to open its exhibition room ({done}/{total})',
  'v2.galleryOpen': 'Visit the exhibition',
  'v2.galleryTitle': '{world}: exhibition room',
  'v2.gallerySub': 'Every picture you painted in this world, framed in gold.',
  'v2.galleryTodo': 'Not painted yet',
  'v2.galleryBack': 'Back to the map',
  'v2.expoDoor': 'Exhibition',
  'v2.expoHubTitle': 'Exhibition',
  'v2.expoHubSub': 'One room for every world. Paint pictures to fill the walls!',
  'v2.expoProgress': '{done}/{total} pictures',
  'v2.expoNone': 'No pictures yet',
  'v2.expoEmpty': 'This room is still empty. Paint your first picture of this world and it will hang here!',
  'v2.expoEmptyCta': 'Go to the map',
  'v2.expoComplete': 'Complete',
  'v2.expoGrand': 'Grand opening!',
  'v2.expoGrandSub': 'Every picture of {world} is on the wall.',
  'v2.expoNew': 'New!',
  'v2.expoHang': 'Hang it in the exhibition',
  'v2.expoBack': 'Back',
  'v2.expoJunoHub': 'Every door is a world. Which gallery shall we visit?',
  'v2.expoJunoEmpty': 'This room is waiting for its very first picture!',
  'v2.expoJunoSome': 'Welcome to the {world} gallery! Tap a picture to look closer.',
  'v2.expoJunoDone': 'Every frame is full. You are a real artist!',
  'v2.expoJunoTap': 'Listen to Juno',
  'v2.expoViewYours': 'Your drawing',
  'v2.expoViewTarget': 'The picture',
  'v2.expoViewNoPhoto': 'No photo of your drawing yet',
  'v2.expoViewDate': 'Painted on {date}',
  'v2.expoViewShare': 'Share with family',
  'v2.expoViewClose': 'Close',
  'v2.expoViewOpen': 'Look closer at {title}',
  'v2.expoLocked': 'Locked',
  'v2.pgPictures': 'Full pictures: object, background, colour and light',
  'v2.finaleLocked': 'Finish the world to see the ending',
  'v2.finalePlay': 'Watch the ending',
  'v2.crossroads': 'Crossroads',
  'v2.crossroadsBody': 'Two worlds meet: finish both to open a crossover',
  'v2.crossOpen': 'Complete {world} to open',
  'v2.crossAnd': '{a} and {b}',
  'v2.crossDone': 'Drawn!',
  // playground
  'v2.pgLevelLocked': 'Opens at level {n}',
  'v2.pgLevelHint': 'Earn a level {n} key in any world',
  'v2.pgCrossover': 'Crossover',
  'v2.pgRemix': 'Remix · 3 cards',
  'v2.pgObserve': 'Draw from real objects',
  'v2.pgCrossLocked': 'Finish both worlds',
  // frames
  'v2.frameGolden': 'Golden {world}',
  'v2.frameGoldenLocked': 'Finish the {world} masterpiece',
};

export const vi: Record<keyof typeof en, string> = {
  'v2.session1': 'Buổi 1: hình và chồng lớp',
  'v2.session2': 'Buổi 2: chi tiết, bóng và màu',
  'v2.breakHint': 'Mỏi tay rồi? Cô đã lưu chỗ con đang vẽ.',
  'v2.takeBreak': 'Nghỉ một chút',
  'v2.needHint': 'Cần gợi ý?',
  'v2.chapter': 'Chương {n}',
  'v2.finaleTitle': 'Kết thúc câu chuyện',
  'v2.storyGo': 'Đi nào!',
  'v2.storyEnd': 'Hết truyện!',
  'v2.guide.scribble': 'Scribble',
  'v2.guide.miso': 'Miso',
  'v2.guide.hatDe': 'Sóc Hạt Dẻ',
  'v2.guide.bolt': 'Bolt',
  'v2.guide.nova': 'Nova',
  'v2.guide.banhBao': 'Bé Bun',
  'v2.remixTap': 'Chạm vào thẻ để lật',
  'v2.remixPick': 'Vẽ thẻ này!',
  'v2.remixTryNew': 'Thử thẻ mới!',
  'v2.remixLast': 'Lần trước',
  'v2.remixOthers': 'Các thẻ còn lại chờ con ở Sân chơi',
  'v2.sceneFar': 'Xa',
  'v2.sceneMid': 'Giữa',
  'v2.sceneNear': 'Gần',
  'v2.sceneHorizon': 'Đường chân trời',
  'v2.sceneOrder': 'Vẽ nền trước, rồi từ phía sau ra phía trước',
  'v2.sceneOrderOverlap': 'Vẽ bạn phía trước trước: các bạn phía sau dừng ở viền',
  'v2.sceneLayout': 'Bố cục {n}',
  'v2.sceneSwap': 'Đổi một bạn',
  'v2.sceneGo': 'Bắt đầu vẽ',
  'v2.pickSubject': 'Chọn hình con muốn vẽ',
  'v2.peekStart': 'Con sẵn sàng nhìn',
  'v2.peekLook': 'Nhìn thật kỹ nhé…',
  'v2.peekHidden': 'Giờ vẽ lại theo trí nhớ nào!',
  'v2.peekOwnPose': 'Vẽ theo trí nhớ, theo dáng của riêng con!',
  'v2.peekNoGuides': 'Không có bước, không nét phụ: con làm được!',
  'v2.peekAgain': 'Xem lại (còn {n} lần)',
  'v2.peekExtra': 'Xem lại (không nhận sao)',
  'v2.peekDone': 'Con vẽ xong rồi',
  'v2.peeksUsed': 'Số lần xem: {n}',
  'v2.checkDone': 'Con kiểm tra xong rồi',
  'v2.checkCount': 'Nhớ được {n}/{total}',
  'v2.obsSafety': 'An toàn trước tiên',
  'v2.obsSafetyOk': 'Con hiểu rồi!',
  'v2.obsPutObject': 'Đặt đồ vật này trước mặt con:',
  'v2.obsCard': 'Thẻ {n}/{total}',
  'v2.obsNext': 'Thẻ tiếp',
  'v2.obsDone': 'Vẽ thôi!',
  'v2.obsPhoto': 'Chụp đồ vật (tuỳ chọn)',
  'v2.obsPhotoTake': 'Chụp ảnh',
  'v2.obsPhotoSkip': 'Không chụp',
  'v2.obsPhotoSaved': 'Chỉ lưu trên máy này',
  'v2.obsCompareNoPhoto': 'Lần này không có ảnh đồ vật, không sao cả!',
  'v2.obsObject': 'Đồ vật của con',
  'v2.obsYours': 'Tranh của con',
  'v2.thenTitle': 'Ngày ấy',
  'v2.nowTitle': 'Bây giờ',
  'v2.thenJuno': 'Tranh mẫu ngày ấy của cô Juno',
  'v2.thenYours': 'Tranh của con ngày ấy',
  'v2.thenSlide': 'Kéo để so sánh',
  'v2.thenShare': 'Tạo thẻ chia sẻ',
  'v2.thenCardTitle': 'Ngày ấy – Bây giờ',
  'v2.share': 'Chia sẻ',
  'v2.save': 'Lưu',
  'v2.printTrace': 'Trang tập đồ',
  'v2.printColour': 'Trang tô màu',
  'v2.printName': 'Tên:',
  'v2.print': 'In',
  'v2.printSave': 'Lưu ảnh',
  'v2.printSkip': 'Bỏ qua',
  'v2.printMaking': 'Đang tạo trang…',
  'v2.celSmall': 'Thắng nhanh!',
  'v2.celKey': 'Con nhận chìa khoá cấp rồi!',
  'v2.celMasterpiece': 'Một kiệt tác!',
  'v2.celGolden': 'Khung vàng đang chờ con trong Phòng tranh',
  'v2.celBadgeStar': 'Sao Hoạ sĩ tự tin!',
  'v2.celBadgeLess': 'Lần sau thử nhìn ít hơn nhé!',
  'v2.celBadgePhoto': 'Lần sau chụp ảnh để nhận sao nhé',
  'v2.confident': 'Hoạ sĩ tự tin',
  'v2.new': 'Mới!',
  'v2.act.doodle': 'Vẽ nhanh',
  'v2.act.core': 'Bài chính',
  'v2.act.remix': 'Biến hoá',
  'v2.act.colouring': 'Tô màu',
  'v2.act.scene': 'Cảnh',
  'v2.act.masterpiece': 'Kiệt tác',
  'v2.act.thenNow': 'Ngày ấy – bây giờ',
  'v2.act.challenge': 'Thử thách',
  'v2.act.observe': 'Đồ thật',
  'v2.act.crossover': 'Kết hợp',
  'v2.act.picture': 'Bức tranh',
  'v2.picLocked': 'Con vẽ bài {name} trước, rồi lên level {n} của thế giới này nhé',
  'v2.picLevel': 'Lên level {n} của thế giới này để vẽ cả bức tranh nhé',
  'v2.picTier': 'Vẽ cả bức tranh',
  'v2.gallery': 'Phòng triển lãm',
  'v2.galleryLocked': 'Vẽ một bức tranh của thế giới này để mở phòng triển lãm ({done}/{total})',
  'v2.galleryOpen': 'Vào phòng triển lãm',
  'v2.galleryTitle': '{world}: phòng triển lãm',
  'v2.gallerySub': 'Mọi bức tranh con đã vẽ ở thế giới này, lồng khung vàng.',
  'v2.galleryTodo': 'Chưa vẽ',
  'v2.galleryBack': 'Về bản đồ',
  'v2.expoDoor': 'Triển lãm',
  'v2.expoHubTitle': 'Phòng triển lãm',
  'v2.expoHubSub': 'Mỗi thế giới một phòng. Vẽ tranh để lấp đầy những bức tường nhé!',
  'v2.expoProgress': '{done}/{total} bức tranh',
  'v2.expoNone': 'Chưa có tranh',
  'v2.expoEmpty': 'Phòng này còn trống. Con vẽ bức tranh đầu tiên của thế giới này để treo lên đây nhé!',
  'v2.expoEmptyCta': 'Về bản đồ',
  'v2.expoComplete': 'Hoàn thành',
  'v2.expoGrand': 'Khai trương!',
  'v2.expoGrandSub': 'Mọi bức tranh của {world} đã lên tường.',
  'v2.expoNew': 'Mới!',
  'v2.expoHang': 'Treo tranh vào phòng triển lãm',
  'v2.expoBack': 'Quay lại',
  'v2.expoJunoHub': 'Mỗi cánh cửa là một thế giới. Mình vào phòng nào nhỉ?',
  'v2.expoJunoEmpty': 'Phòng này đang chờ bức tranh đầu tiên của con đấy!',
  'v2.expoJunoSome': 'Chào mừng con đến phòng tranh {world}! Chạm vào một bức để xem gần hơn nhé.',
  'v2.expoJunoDone': 'Mọi khung tranh đều đã đầy. Con là một hoạ sĩ thật sự!',
  'v2.expoJunoTap': 'Nghe Juno nói',
  'v2.expoViewYours': 'Tranh con vẽ',
  'v2.expoViewTarget': 'Bức tranh mẫu',
  'v2.expoViewNoPhoto': 'Chưa có ảnh tranh con vẽ',
  'v2.expoViewDate': 'Vẽ ngày {date}',
  'v2.expoViewShare': 'Chia sẻ với gia đình',
  'v2.expoViewClose': 'Đóng',
  'v2.expoViewOpen': 'Xem gần bức {title}',
  'v2.expoLocked': 'Đang khoá',
  'v2.pgPictures': 'Tranh hoàn chỉnh: vật, khung cảnh, màu và ánh sáng',
  'v2.finaleLocked': 'Hoàn thành thế giới để xem đoạn kết',
  'v2.finalePlay': 'Xem đoạn kết',
  'v2.crossroads': 'Ngã tư',
  'v2.crossroadsBody': 'Hai thế giới gặp nhau: hoàn thành cả hai để mở bài kết hợp',
  'v2.crossOpen': 'Hoàn thành {world} để mở',
  'v2.crossAnd': '{a} và {b}',
  'v2.crossDone': 'Đã vẽ!',
  'v2.pgLevelLocked': 'Mở ở cấp {n}',
  'v2.pgLevelHint': 'Nhận chìa khoá cấp {n} ở bất kỳ thế giới nào',
  'v2.pgCrossover': 'Kết hợp',
  'v2.pgRemix': 'Biến hoá · 3 thẻ',
  'v2.pgObserve': 'Vẽ từ đồ thật',
  'v2.pgCrossLocked': 'Hoàn thành cả hai thế giới',
  'v2.frameGolden': 'Khung vàng {world}',
  'v2.frameGoldenLocked': 'Hoàn thành Kiệt tác {world}',
};
